var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "append-to-body": true,
      "title": _vm.title,
      "visible": _vm.show,
      "before-close": _vm.onClose
    },
    on: {
      "update:visible": function ($event) {
        _vm.show = $event;
      }
    }
  }, [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }